import { useTranslation } from 'next-i18next/pages';

import AnonymousWrapper from '@pflegia/ui/shared/wrapper/AnonymousWrapper';

import { FUNNEL } from '@shared/application/constants';

import { SectionTitle } from '../section/Section.component';

interface AboutUsProps {
  anonymous: boolean;
  aboutUs: string;
}

export const AboutUs = ({ aboutUs, anonymous }: AboutUsProps): React.JSX.Element => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'aboutUs' });
  return (
    <div className='rounded-2xl bg-white px-6 pt-4 pb-6 md:p-12'>
      <div className='flex flex-col'>
        <SectionTitle t={t} titleKey='title' />
        <AnonymousWrapper anonymous={anonymous} href={FUNNEL}>
          <div className='text-default text-base leading-7 font-normal md:mt-0' dangerouslySetInnerHTML={{ __html: aboutUs }} />
        </AnonymousWrapper>
      </div>
    </div>
  );
};

export default AboutUs;
